import { Chrome, ArrowRight, Check, Download } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import { Button } from "@/components/ui/button";

const Install = () => {
  const { t } = useLanguage();

  return (
    <section id="install" className="py-24 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="relative rounded-xl overflow-hidden bg-foreground text-background p-8 md:p-12 text-center">
          {/* Subtle pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[length:24px_24px]" />
          </div>

          <div className="relative">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-background/10 mb-6">
              <Download className="w-6 h-6" />
            </div>

            <h2 className="text-2xl md:text-3xl font-semibold mb-4">
              {t('localRoute', 'ctaReadyTitle')}
            </h2>
            <p className="text-background/70 max-w-lg mx-auto mb-8">
              {t('localRoute', 'ctaReadySubtitle')}
            </p>

            <Button
              size="lg"
              variant="secondary"
              className="group gap-2"
              asChild
            >
              <a 
                href="https://chrome.google.com/webstore"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Chrome className="w-4 h-4" />
                Install from Chrome Web Store
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
            </Button>

            <div className="flex items-center justify-center gap-6 mt-8 text-sm text-background/60">
              <span className="flex items-center gap-2">
                <Check className="w-4 h-4" />
                {t('localRoute', 'checkFree')}
              </span>
              <span className="flex items-center gap-2">
                <Check className="w-4 h-4" />
                {t('localRoute', 'checkNoAccount')}
              </span>
              <span className="flex items-center gap-2">
                <Check className="w-4 h-4" />
                {t('localRoute', 'checkPrivate')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Install;
